import Vue from 'vue'

Vue.prototype.$download = function (data, filename) {
  const link = document.createElement('a')
  const blob = new Blob(["\ufeff", data])
  const url = URL.createObjectURL(blob)
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}